import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl } from "../../constants";
import ExternalLink from "../links/externalLink/ExternalLink";
import styles from "./Footer.module.css";

// Here we request the information for the footer
const Footer = ({ specsheetStyle }) => {
  const [contacts, setContacts] = useState([]);

  // When the page is loaded we get the contact information from the database.
  useEffect(() => {
    let routeUrl = `${apiUrl}/api/specsheets/contact`;

    if (specsheetStyle) {
      routeUrl = `${apiUrl}/api/specsheets2/contact`;
    }

    async function getData() {
      try {
        const { data } = await axios.get(routeUrl);
        setContacts(data[0].contact);
      } catch (e) {
        console.error(e);
      }
    }

    getData();
  }, []);

  return (
    <div className={`${styles["blue-container"]} ${specsheetStyle ? styles.footerRedesign : ""}`}>
      <div className={`${styles.footer} ${specsheetStyle ? styles.footerRedesignInner : ""}`}>
        <div className={styles["top-container"]}>
          <div className={styles["logo-contact-wrapper"]}>
            <svg className={styles["w-logo"]} viewBox="0 0 800 800">
              <g style={{ fill: "#7366d5" }}>
                <g data-name="weborama w">
                  <circle fill="#7366d5" cx="400" cy="400" r="400"/>
                  <path fill="#fff" d="M238.3,355.1c-46.7-32.6-115.5,4.2-114,61.3-1.5,57.1,67.3,93.9,114,61.3v12.2h33v-147h-33v12.2h0ZM197.8,456.9c-53.2-1-53.2-80.1,0-81,53.2,1,53.2,80.1,0,81Z"/>
                  <path fill="#fff" d="M400.3,355.1c-49.4-34.6-121.5,8.9-113.6,68.8,3.8,53.5,69.9,84.7,113.6,53.8v12.2h33v-219h-33v84.2h0ZM405.9,415.9c-3.8,6.4-15.1,13.3-33.6,24.7-19.1,10.4-30.8,16.6-38.2,16.7-4.7-9.5-4.7-72.5,0-82,10.6-1.5,65.6,32.1,71.8,40.6h0Z"/>
                  <polygon fill="#fff" points="632.9 343 610.7 429.6 581.2 343 534.3 343 504.8 429.6 482.6 343 447.8 343 485.5 490 519.7 490 557.8 378.5 595.8 490 630.1 490 667.7 343 632.9 343"/>
                </g>
              </g>
            </svg>
          </div>

          <div className={styles["contact-container"]}>
            <p className={styles.contact}>Contact Support</p>
            <div className={styles["contact-box"]}>
              {contacts &&
                contacts.map((contact) => {
                  return (
                    <ul key={contact.country}>
                      <li>{contact.country}</li>
                      <li>{contact.email}</li>
                      <li>{contact.telephone}</li>
                    </ul>
                  );
                })}
            </div>
          </div>

          <p className={styles.copyright}>
            Copyright © {new Date().getFullYear()}&nbsp;
            <span>
              <ExternalLink
                link="https://www.adways.com/"
                children="Adways Netherlands"
              />
            </span>
            . All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
